import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {AuditService} from './audit.service';
import {Audit} from './audit.model';
import {HttpErrorResponse} from '@angular/common/http';
import {TableData} from '../shared/shared.model';

@Injectable()
export class AuditResolver implements Resolve<Audit> {
  constructor(
    private router: Router,
    private auditService: AuditService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Audit> {
    return this.auditService.getAudit(route.url[0].path)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          this.router.navigateByUrl('/audit');

          return throwError(error);
        })
      );
  }
}

@Injectable()
export class AuditListResolver implements Resolve<TableData<Audit>> {
  constructor(
    private auditService: AuditService
  ) {}

  resolve(): Observable<TableData<Audit>> {
    return this.auditService.getAuditList();
  }
}
